import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import TextField from "../../Form/TextField";
import HiddenField from "../../Form/HiddenField";
const FolderForm = ({ name }) => {
    return (_jsxs(_Fragment, { children: [_jsx(HiddenField, { name: name ? name + ".id" : "id" }), _jsx(TextField, { label: "Folder Name", name: name ? name + ".name" : "name", required: true, maxLength: 64 })] }));
};
export default FolderForm;
